import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';

import { brandColors } from '@/app/constants';
import CircleWarningIcon from '@/component-library/primitives/Icons/CircleWarningIcon/CircleWarningIcon';

import './styles.css';
import 'react-phone-input-2/lib/material.css';

export type PhoneCodeInputSize = 'large' | 'small';
interface PhoneCodeInputProps {
  placeholder: string;
  name: string;
  error?: string;
  control: any;
  size?: PhoneCodeInputSize;
  className?: string;
  label?: string;
  optional?: boolean;
  disabled?: boolean;
}

export const PhoneCodeInput = ({
  error,
  control,
  placeholder,
  name,
  size = 'small',
  className,
  label,
  optional = false,
  disabled = false,
}: PhoneCodeInputProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col relative">
      {label && (
        <label
          className={`block text-sm mb-1 font-medium
                ${error ? 'text-custom-red' : 'text-custom-darkSilver'}
                ${disabled && 'opacity-50'}
              `}
        >
          {label} {optional && <span>({t('InputField.optionalLabel')})</span>}
        </label>
      )}

      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <PhoneInput
            specialLabel=""
            placeholder={placeholder}
            value={value}
            onChange={(phone) => onChange(`+${phone}`)}
            disabled={disabled}
            country="us"
            inputStyle={{
              position: 'relative',
              opacity: `${disabled ? '0.5' : '1'}`,
              border: 'transparent',
              borderRadius: '0.5rem',
              width: '100%',
              padding: '12px 16px 12px 105px',
              fontSize: '14px',
              color: '#000000ff',
              fontFamily: 'Inter',
              fontWeight: '400',
              height: `${size === 'small' ? '48px' : '56px'}`,
              boxShadow: 'none',
              outline: 'none',
              backgroundColor: brandColors.silver,
            }}
            inputClass="&.country.highlight"
            buttonStyle={{
              borderRight: `1px solid ${brandColors.mediumSilver}`,
              paddingRight: '32px',
              paddingLeft: '2px',
              height: '24px',
              marginTop: '12px',
            }}
            dropdownStyle={{
              backgroundColor: '#fff',
              color: brandColors.darkSilver,
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14px',
              marginTop: '30px',
              padding: '8px',
            }}
            dropdownClass={`[&::-webkit-scrollbar]:!hidden [-ms-overflow-style:!none] [scrollbar-width:!none]`}
          />
        )}
      />
      {error && (
        <p className="text-custom-red mt-1 text-xs font-medium flex flex-row items-center gap-1">
          <CircleWarningIcon /> {error}
        </p>
      )}
    </div>
  );
};
